import { useTranslation } from "react-i18next";
import { useTenders } from "../../../tools/api";
import Layouts from "../../layout/layouts";
import styles from "./Order.module.scss";
import { Tabs } from "antd";
import Winner from "./modules/winner";
import Tables from "./modules/tables";
import Participation from "./modules/participation";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { isEmpty } from "../../../tools/tools";
const Order = () => {
  const [t] = useTranslation("global");
  const { QueryCurrentUserBids } = useTenders();
  const [searchParam] = useSearchParams();

  const [activeTab, setActiveTab] = useState("1");
  useEffect(() => {
    if (!isEmpty(searchParam.get("localInvoiceId"))) {
      setActiveTab("3");
    }
  }, []);

  return (
    <>
      <div className="transaction_container">
        <div className="title">
          <h3>سفارش های من</h3>
        </div>
        <div className="holder_tabs">
          <Tabs
            activeKey={activeTab}
            onChange={(e) => {
              setActiveTab(e);
            }}
            items={[
              {
                key: "1",
                label: "در حال برگزاری",
                children: <Participation />,
              },
              {
                key: "2",
                label: "پایان یافته",
                children: <Tables />,
              },
              {
                key: "3",
                label: "برنده شده",
                children: <Winner />,
              },
            ]}
          />
        </div>
      </div>
    </>
  );
};

export default Order;
